import API from '../services/api'
export default {
    data() {
        return {
            click_id: null,
            QUERY: this.getQuery(window.location.search),
            key: null
        }
    },
    mounted() {
        if (!this.QUERY.click_id) {
            this.key = this.keyGenerate(12);
            let data = JSON.stringify(this.QUERY);
            let ths = this;
            API.getID(data, this.key)
                .then(response => (ths.click_id = response.data))
                .catch(error => console.log(error));
        } else {
            this.click_id = this.QUERY.click_id;
        }
    },
    methods: {
        clearNumber(num) {
            return num.replace(/\D+/g, "");
        },
        sendNumber() {
            let phone = this.clearNumber(this.userPhone);
            API.getSHA(phone, this.click_id, this.key)
                .then(response => (resp = response))
                .catch(error => console.log(error));
        },
        keyGenerate(length) {
            let text = "";
            let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            for (let i = 0; i < length; i++) {
                text += possible.charAt(Math.floor(Math.random() * possible.length));
            }
            return text;
        },
        getQuery(string) {
            return string.slice(1).split("&")
                .map((queryParam) => {
                    let kvp = queryParam.split("=");
                    return { key: kvp[0], value: kvp[1] }
                })
                .reduce((query, kvp) => {
                    query[kvp.key] = kvp.value;
                    return query
                }, {})
        }
    }
} 